import { Box, Typography } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const ImageBanner = (props) => {
    const tenantResource = useSelector(state => state.tenant.tenanantResource);
    const { homePageBanner, overlayImage } = tenantResource;
    return (
        <Box>
            <div className='wrapper' style={{ backgroundImage: `url(${homePageBanner})` }} >
                <Box className='contentWrapper'
                    style={{ backgroundImage: `url(${overlayImage})` }}
                >
                    <Box className='bannerTextWrapper'>
                        <Typography className={props.className} id="bannerTitle" variant='h1'>{props.title}</Typography>
                    </Box>
                </Box>
            </div>
        </Box>
    );
};

ImageBanner.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
};
//
export default ImageBanner;
